var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticStyle:{"color":"red","margin":"0 5px","font-size":"1.2em"}},[_vm._v(" ("+_vm._s(_vm.value)+")")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }